import { usePageMeta } from '@/hooks/usePageMeta';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface iNotFoundPageProps {}

const NotFoundPage: FunctionComponent<iNotFoundPageProps> = () => {
  const { t } = useTranslation('common');
  usePageMeta({ title: [t('notFound.title')] });
  return (
    <div className='w-full h-full flex items-center flex-col justify-center'>
      <h1 className='text-8xl font-bold'>{t('notFound.title')}</h1>
      <p className='mt-2 mb-8'>{t('notFound.description')}</p>
      <Link to='/' className='text-blue-500 underline'>
        {t('notFound.backHome')}
      </Link>
    </div>
  );
};

export default NotFoundPage;
